import { Component, input } from '@angular/core';
import { LegalSection } from './legal-content';

/**
 * Reusable view สำหรับ render sections ของ legal document (terms / privacy)
 * ใช้ทั้งใน standalone page (terms.page, privacy.page) และ embedded ใน consent popup
 */
@Component({
  selector: 'app-legal-sections-view',
  standalone: true,
  template: `
    <div class="space-y-8">
      @for (s of sections(); track s.id) {
        <section [id]="s.id" class="scroll-mt-20" [attr.data-testid]="'section-' + s.id">
          <div class="flex items-start gap-2 mb-3">
            <h2 class="text-xl font-bold flex-1" style="color: var(--color-text-primary);">
              {{ s.title }}
            </h2>
            @if (s.audience === 'bidder') {
              <span class="text-[11px] px-2 py-0.5 rounded-full font-semibold shrink-0"
                    style="background: #dbeafe; color: #1e40af;">ผู้ประมูล</span>
            } @else if (s.audience === 'owner') {
              <span class="text-[11px] px-2 py-0.5 rounded-full font-semibold shrink-0"
                    style="background: #dcfce7; color: #166534;">เจ้าของร้านค้า</span>
            } @else {
              <span class="text-[11px] px-2 py-0.5 rounded-full font-semibold shrink-0"
                    style="background: #f3f4f6; color: #374151;">ทั้งสอง</span>
            }
          </div>
          <div class="space-y-3 text-sm leading-7 text-text-secondary">
            @for (p of s.paragraphs; track $index) {
              @let parts = bulletize(p);
              @if (parts.bullets.length === 0) {
                <p>{{ parts.lead }}</p>
              } @else {
                <div>
                  <p class="mb-1">{{ parts.lead }}</p>
                  <ul class="list-disc pl-6 space-y-1">
                    @for (b of parts.bullets; track $index) {
                      <li>{{ b }}</li>
                    }
                  </ul>
                </div>
              }
            }
          </div>
        </section>
      }
    </div>
  `,
})
export class LegalSectionsView {
  /** sections ที่จะ render — terms หรือ privacy */
  readonly sections = input.required<LegalSection[]>();

  /** แปลง paragraph ที่มี "\n- " bullet → array ของ bullet เพื่อ render <ul> */
  bulletize(paragraph: string): { lead: string; bullets: string[] } {
    if (!paragraph.includes('\n- ')) return { lead: paragraph, bullets: [] };
    const [lead, ...rest] = paragraph.split('\n- ');
    return { lead, bullets: rest };
  }
}
